import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { SmartBusinessHoursView } from './smart-hours-view';
import { proxyReadHoursConfig } from './proxy-read-hours-config';

export const SmartBusinessHoursConnector = ({
  id,
  hideTitle,
}) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const i18n = useContext(I18nContext);
  const { hours } = proxyReadHoursConfig(siteConfig, id);

  return (
    <React.Fragment>
      <SmartBusinessHoursView
        id={id}
        hours={hours}
        i18n={i18n}
        hideTitle={hideTitle}
      />
    </React.Fragment>
  );
};

SmartBusinessHoursConnector.propTypes = {
  id: PropTypes.string.isRequired,
  hideTitle: PropTypes.bool,
};

SmartBusinessHoursConnector.defaultProps = {
  hideTitle: false,
};

